import { useEffect } from "react";
import { z } from "zod";
import { localStore } from "../lib/store";
import { androidRequestReview, isAndroidApp } from "../tools/android";
import { iosRequestReview, isIOSApp } from "../tools/ios";

const reviewRequestCountStore = localStore("countReqReview", 0, z.number());

export function useRequestReview() {
  useEffect(() => {
    function requestReview() {
      const count = reviewRequestCountStore.get();

      if (count > 0 && (!(count % 7) || count === 1)) {
        if (isIOSApp()) iosRequestReview();
        if (isAndroidApp()) androidRequestReview();
      }

      reviewRequestCountStore.set(count + 1);
    }
    if (isIOSApp() || isAndroidApp()) {
      requestReview();
    }
  }, []);
}
